import React from "react";
import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet";

function PageHero({ title, eyebrow, intro, quote, quoteRef, metaTitle }) {
  return (
    <>
      {metaTitle ? (
        <Helmet>
          <title>{metaTitle}</title>
        </Helmet>
      ) : null}
      <section className="page-hero">
        <Container>
          <div className="page-hero__content">
            {eyebrow ? <p className="page-eyebrow">{eyebrow}</p> : null}
            <h1>{title}</h1>
            {intro ? <p className="page-hero__intro">{intro}</p> : null}
            {quote ? (
              <div className="page-hero__quote">
                <blockquote>{quote}</blockquote>
                {quoteRef ? <cite>{quoteRef}</cite> : null}
              </div>
            ) : null}
          </div>
        </Container>
      </section>
    </>
  );
}

export default PageHero;
